export default "__VITE_PUBLIC_ASSET__eba07514__"